import Dispatcher from "events-dispatch";
import { init as initImageInput } from "../../../components/image-input";
import Toast from "../../../components/modal/toast";
import ModalForm from "../../../components/modals/modal.form";
import { init as initInput } from "../../../components/uic-input";
import { initLoader } from "../../../services/init-loader-button";

let companyPreview, form;

let displayCompany = companyData => {
    companyPreview.innerHTML = companyData.html;
    form.elements.companyId.value = companyData.companyId;
};

const initCompanyModal = (config) => {
    let companyModal = Object.create(null);
    new Dispatcher(companyModal);

    let modal = document.getElementById('company-create');

    modal.querySelectorAll("[data-uic=input]")
        .forEach(initInput);

    const imageInput = initImageInput(modal.querySelector("[data-image-input]"));

    let companyModalForm = new ModalForm(modal, {
        handleErrors: (errors) => {
            let toastMsgs = [];

            for (const key in errors) {
                const input = document.querySelector(`[data-uic=input] [name="${ key }"]`);

                if (input) {
                    input.closest("[data-uic=input]").classList.add("error");
                }

                toastMsgs.push(errors[key]);
            }

            if (toastMsgs.length) {
                Toast.open(toastMsgs.join(". "), { state: "error" });
            }
        },
        validationRules: config.validationRules || {},
        afterSubmit: (res) => {
            companyModalForm.close();
            companyModalForm.reset();
            imageInput.reset();
            modal.querySelectorAll("[data-uic=input] input, [data-uic=input] textarea")
                .forEach(item => item.dispatchEvent(new Event("input")));
            companyModal.trigger("create", res);
        }
    });

    let form = companyModalForm.nodes.form;
    initLoader(form, "avatar", {
        accept: "image",
        multiple: false
    });

    companyModal.open = () => {
        companyModalForm.open();
        imageInput.update();
    };

    return companyModal;
}

const initCompanyBlock = (config) => {
    form = config.form;
    companyPreview = form.querySelector('[data-company-preview]');

    if (config.displayCompany) {
        displayCompany = config.displayCompany;
    }

    let addCompanyButton = form.querySelector('[data-add-company]');

    if (addCompanyButton) {
        let modal = initCompanyModal(config);

        addCompanyButton.addEventListener("click", () => {
            modal.open();
        });
        modal.on("create", companyData => {
            displayCompany(companyData);
        });
    }

    let companiesSuggestListElement = document.getElementById('companies-list');
    if (companiesSuggestListElement) {
        onDomReady.then(() => {
            let companiesSuggestList = companiesSuggestListElement.suggestBlock;
            companiesSuggestList.on('change', (data) => {

                if (companyPreview && data && data.item) {
                    companiesSuggestList._clear();
                    let html = `<div class="company-preview flex-middle pa-2">

                        <div class="company-preview__text">
                            ${data.itemData.text}
                        </div>
                    </div>`;

                    displayCompany({ html, companyId: data.itemData.value })


                }

            })
        })

    }
}

export { initCompanyBlock };
